import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { QBRReportModalContent } from './QBRReportModalContent'

interface ISaveSettingsModalProps {
  show: boolean
  onClose: () => void
}

export const QBRReportModal = ({ show, onClose }: ISaveSettingsModalProps) => {
  const contentProps = useMemo(() => ({ onClose }), [onClose])
  return (
    <ModalDialog
      size={'xs'}
      content={QBRReportModalContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={onClose}
    />
  )
}
